import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

type GetLineItemNotReturnedQuantityParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * A Line item can be split into different parts in the context of a return request.
 * This function returns the quantity of the line item that has not been returned.
 *
 * For example, the order contains 3 white t-shirt
 *
 * ***********************************
 * White t-shirt                   x3
 * ***********************************
 *
 * The customer returns 2 white t-shirts.
 * This function would simply return the number 2
 */
export function getLineItemNotReturnedQuantity({
  lineItem,
}: GetLineItemNotReturnedQuantityParams): number {
  return lineItem.quantity_bought - lineItem.quantity;
}
